<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div>
    <Notifications
      v-if="isNotificationsModalOpen"
      :props="{
        closeModal: closeNotificationsModal,
      }"
      data-testid="notifications-modal"
    />

    <!-- Replace BModal with custom modal implementation -->
    <Teleport to="body">
      <div
        v-if="isSwitchModalOpen"
        class="modal-overlay"
        data-testid="switch-role-modal"
        @click.self="isSwitchModalOpen = false"
        >
        <div class="modal-content modal-md" style="background-color: white;">
          <div class="simple-modal__header">
            <h4
              style="text-align: center; color:rgb(5, 19, 118);"
              data-testid="switch-role-title"
            >
              {{ title }}
            </h4>
          </div>
          <div class="row">
            <div
              v-for="item in isMultipleRoles"
              :key="item.roleId"
              class="col-sm-12 col-md-6 col-lg-6"
            >
              <div class="switchRoleComponent">
                <button
                  type="button"
                  :class="[(item.roleType === currentUserRole) ? 'switchbtn-active' : 'switchbtn']"
                  @click="chnageRole(item)"
                  :data-testid="`role-switch-button-${item.roleType}`"
                >
                  <p style="margin-top: 50%;margin-left: -5px">
                    {{ item.roleType }}
                  </p>
                </button>
              </div>
            </div>
          </div>
          <div class="text-right mt-3" />
        </div>
      </div>
    </Teleport>

    <Teleport to="body">
      <div v-if="isSwitching" class="modal-overlay" data-testid="loading-modal">
        <div class="modal-content modal-sm" style="background-color: white;">
          <span class="bankshiftHeaderText">Loading.....</span>
        </div>
      </div>
    </Teleport>

    <!-- Main navigation bar -->
    <BNavbar style="background-color: #051376;" type="dark" class="p-0 ">
      <div class="container pb-0 top-nav d-flex  align-items-center">
        >
        <BNavbarBrand style="display: flex; float:left !important;">
          <img src="../../assets/logo.svg" width="136" height="33" alt="Logo" data-testid="nav-logo" />
          <div class="envNmae" v-if="env">{{ env }}</div>
        </BNavbarBrand>

        <BNavbarNav
          class="ml-auto d-flex"
          v-if="isLogged && account"

        >

          <!-- Create Shift -->
          <BNavItem
            :class="$style.navItem"
            :to="{ name: 'create-new-shift' }"
            v-if="getAccess('Post a shift and post similar') && checkPostAShiftPermission()"
            data-testid="nav-create-shift"
          >
            <SuccessButton
              :title="checkRolePermission('DRAFT_A_SHIFT') ? 'Draft a Shift' : 'Create a New Shift'"
              class="successBtn"
            />
          </BNavItem>

          <!-- Messages -->
          <BNavItem
            v-if="chatPermissions()"
            :class="{
              [$style.navItem]: true,
              [$style.userHover]: true,
              'message-container': true,
            }"
            :to="{ name: 'messageslist' }"
            exact
            data-testid="nav-messages"
          >
            <i class="bi bi-chat-dots text-white fs-5" variant="light" />
            <BBadge v-if="totalNotifications > 0" class="message-badge" pill>
              {{ totalNotifications }}
            </BBadge>
          </BNavItem>

          <!-- Notifications -->
          <BNavItem
            :class="{
              [$style.navItem]: true,
              [$style.userHover]: true,
              'notification-container': true,
            }"
            @click="openNotificationsModal"
            data-testid="nav-notifications"
          >
            <i class="bi bi-bell text-white fs-5" variant="light" />
            <BBadge
              v-if="notificationsCount"
              class="notification-badge"
              variant="danger"
              pill
            >
              {{ notificationsCount }}
            </BBadge>
          </BNavItem>

          <!-- Switch Role -->
          <BNavItem
            v-if="account.newUserRoles.length > 1"
            :class="{
              [$style.navItem]: true,
              [$style.userHover]: true,
            }"
            @click="switchRole"
            class="text-white"
            data-testid="nav-switch-role"
          >
            <i class="bi bi-arrow-left-right text-white" variant="light" style="color:white" />
          </BNavItem>

          <!-- User Menu -->
          <BNavItem
            :class="{
              [$style.navItem]: true,
              [$style.userHover]: true,
            }"
            data-testid="nav-user-menu"
          >
            <div
              id="user-hover"
              ref="userMenu"
              :class="$style.userMenu"
              class="d-flex align-items-center"
              @click="togglePopover"
              data-testid="user-menu-toggle"
            >
              <BAvatar
                :src="account.imageUrl"
                size="35px"
                class="mr-3 text-white"
                v-if="account.imageUrl"
                data-testid="user-avatar-img"
              />
              <BAvatar
                size="35px"
                class="avatar mr-3 text-white"
                v-else
                data-testid="user-avatar-initials"
              >
                {{ account.firstname[0] + account.lastname[0] }}
              </BAvatar>
              <div>
                <div :class="$style.role">{{ currentUserRole === 'ADMIN' ? 'Trust Admin' : currentUserRole }}</div>
                <div :class="$style.user">{{ account.firstname }} {{ account.lastname }}</div>
              </div>
              <i
                class="bi bi-caret-up-fill ml-3 text-white"
                v-if="isOpenPopover"
                style="width: 12px; height: 8px; color:white"
                variant="light"
              />
              <i
                class="bi bi-caret-down-fill ml-3 text-white"
                v-else
                style="width: 12px; height: 12px;"
                variant="light"
              />

              <!-- User Popover -->
              <BPopover
                triggers="click"
                style="margin-top:60px !important"
                placement="bottomleft"
                v-model="isOpenPopover"
                target="user-hover"
                custom-class="popoverList"
              >
                <div
                  @click="userSettings"
                  :class="$style.listItem"
                  class="d-flex justify-content-start align-items-center"
                  data-testid="user-settings"
                >
                  <i class="bi bi-gear-fill" style="width: 16px; height: 16px; color:#051376" />
                  <div class="ml-2">Account Settings</div>
                </div>
                <div
                  @click="logOut"
                  :class="$style.listItem"
                  class="d-flex justify-content-start align-items-center"
                  data-testid="user-logout"
                >
                  <img src="../../assets/sign-out-icon.svg" class="logout-icon" alt="icon" />
                  <div class="ml-2">Log Out</div>
                </div>
              </BPopover>
            </div>
          </BNavItem>
        </BNavbarNav>
      </div>
    </BNavbar>
  </div>
</template>

<script setup>
import {
	ref, computed, onMounted, watch, onBeforeUnmount,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import _ from 'lodash';
import Swal from 'sweetalert2';
import {
	// BIconChatDots,
	// BIconBell,
	// BIconCaretUpFill,
	// BIconCaretDownFill,
	// BIconGearFill,
	// BIconArrowLeftRight,
	BNavbar,
	BNavbarBrand,
	BNavbarNav,
	BNavItem,
	BBadge,
	BModal,
	BAvatar,
	BPopover,
} from 'bootstrap-vue-next';
import { getUnreadMessagesCounter, subscribeNotifications, unSubscribeNotifications } from '../../firebaseApi';
import { roleType, checkPermission } from '../../constants/roleCheck.js';
import SuccessButton from './SuccessButton.vue';
import Notifications from '../Notifications/Notifications.vue';
import { constants } from '@/helpers/constants';

const { roles, newRoles } = constants;

// Store and router setup
const store = useStore();
const router = useRouter();

// Reactive state
const isOpenPopover = ref(false);
const isNotificationsModalOpen = ref(false);
const isLoadingOptions = ref(false);
const isSwitchModalOpen = ref(false);
const isMultipleRoles = ref([]);
const title = ref('');
const env = ref('');
const userMenu = ref(null);

// Computed properties
const currentUserRole = computed(() => store.state.usersStore.currentUserRoleLevel);
const currentTrustId = computed(() => store.state.organizationStore.currentTrustId);
const globalFeaturelist = computed(() => store.state.organizationStore.globalFeaturelist);
const currentUserRoleLevel = computed(() => store.state.usersStore.currentUserRoleLevel);
const currentUserRolePermissions = computed(() => store.state.currentUserRolePermissions);
const currentUserRoleType = computed(() => store.state.usersStore.currentUserRoleType);
const isSwitching = computed(() => store.state.organizationStore.isSwitching);
const account = computed(() => store.getters.account);
const isLogged = computed(() => store.getters.isLogged);
const totalNotifications = computed(() => store.getters['messenger/totalNotifications']);
const notifications = computed(() => store.getters.notifications);
const menu = computed(() => store.getters.menu);
const db = computed(() => store.getters.firebaseDb);
const notificationsCount = computed(() => store.getters.notificationsCount);

// Set environment label based on hostname
const setEnvironment = () => {
	const hostprefix = window.location.hostname.split('.')[0];
	switch (hostprefix) {
	case 'web-dev':
		env.value = 'DEV';
		break;
	case 'web-qa':
		env.value = 'STAGE';
		break;
	case 'web-ref':
		env.value = 'REF';
		break;
	case 'web-demo':
		env.value = 'DEMO';
		break;
	default:
		env.value = '';
	}
};

// Load user data
const loadUserData = async () => {
	const token = window.localStorage.getItem('token');
	const initialLoading = true;
	if (token) {
		await store.dispatch('getAccountData', initialLoading);
	}
	if (!isLogged.value) {
		store.dispatch('completeInitialLoad');
	}
};

// Chat permissions check
const chatPermissions = () => {
	const permissions = [
		'CREATE_CHATS_TRUST_ADMIN', 'CREATE_CHATS_MANAGER', 'CREATE_CHATS_MASTER_ADMIN',
		'VIEW_CHATS_TRUST_ADMIN', 'VIEW_CHATS_MANAGER', 'VIEW_CHATS_MASTER_ADMIN',
	];
	const findCommon = _.intersection(currentUserRolePermissions.value, permissions);
	return findCommon?.length > 0;
};

// Post a shift permission check
const checkPostAShiftPermission = () => {
	const permissions = [
		'POST_A_SHIFT', 'DRAFT_A_SHIFT',
	];
	const findCommon = _.intersection(currentUserRolePermissions.value, permissions);
	return findCommon?.length > 0;
};

const checkRolePermission = (item) => checkPermission(currentUserRolePermissions.value, item);

const getAccess = (name) => globalFeaturelist.value.includes(name);

const closeNotificationsModal = () => {
	isNotificationsModalOpen.value = false;
	
	store.dispatch('loadNotificationsCount');
};

const openNotificationsModal = () => {
	isNotificationsModalOpen.value = true;
};

const togglePopover = () => {
	isOpenPopover.value = !isOpenPopover.value;
};

const userSettings = () => {
	router.push({ name: 'users-settings' });
	isOpenPopover.value = false;
};

const logOut = () => {
	unSubscribeNotifications(db.value, account.value?.id);
	isOpenPopover.value = false;
	store.dispatch('messenger/setNotifications', {});
	store.dispatch('authLogout');
	router.push('/sign-in');
};

const switchRole = () => {
	title.value = 'Choose Your Role';
	isSwitchModalOpen.value = true;
	const result = (account.value.newUserRoles?.filter((item) => item.roleType != 'NURSE' && item.roleId));
	isMultipleRoles.value = [...new Map(result.map((item) => [item.roleId, item])).values()];
};

const chnageRole = async (item) => {
	store.commit('SET_CURRENT_USER_ROLE', item.roleId);
	store.commit('SET_CURRENT_USER_ROLE_LEVEL', item.roleType);
	window.localStorage.setItem('currentUserRole', item.roleId);
	window.localStorage.setItem('currentUserRoleLevel', item.roleType);
	isSwitchModalOpen.value = false;

	const resultRoleType = roleType(account.value.newUserRoles);
	if (resultRoleType) {
		const currentRoleLocal = window.localStorage.getItem('currentUserRole');
		const filterRole = account.value.newUserRoles.filter((item) => item.roleId === currentRoleLocal);
		if (filterRole && filterRole.length > 0) {
			store.commit(
				'SET_CURRENT_USER_ROLE_TYPE',
				filterRole[0]?.role?.length > 0 && filterRole[0]?.role[0]?.roleLevel === null
					? 'SUPER-ADMIN'
					: filterRole[0]?.role[0]?.roleLevel,
			);
			store.dispatch('setCurrentTrustId', filterRole[0].trustId);
			store.commit('SET_CURRENT_USER_ROLE_LEVEL', filterRole[0].roleType);
		}
	}

	store.commit('SET_IS_SWITCHING', true);
	await store.dispatch('getAccountData');
	await navigateTo(item);
	setTimeout(() => {
		store.commit('SET_IS_SWITCHING', false);
	}, 3000);
};

const navigateTo = async (theRole) => {
	if (theRole.role?.length > 0) {
		if (theRole.role[0].isDefault === false) {
			router.push({ path: '/login-default', query: { loginDefault: true } }).catch(() => {});
		} else if (currentUserRoleType.value === 'SUPER-ADMIN') {
			router.push('/trust-lists').catch(() => {});
		} else if (currentUserRoleType.value === 'ADMIN') {
			if (theRole.isActive) {
				router.push(`/trust/${currentTrustId.value}/statistics-details`).catch(() => {});
			} else {
				await Swal.fire({
					title: 'Error',
					text: 'Your permissions are revoked',
					icon: 'error',
				});
				setTimeout(() => { store.dispatch('authLogout'); }, 500);
			}
		} else if (currentUserRoleType.value === 'MANAGER' && jobManagerPermissions()) {
			router.push('/jobs/list').catch(() => {});
		} else if (currentUserRoleType.value === 'MANAGER' && checkRolePermission('APPROVE_ENDORSEMENT_REQUESTS')) {
			router.push('/nurseUsers/approvedUser').catch(() => {});
		} else {
			router.push({ path: '/login-default', query: { loginDefault: true } }).catch(() => {});
		}
	}
};

const jobManagerPermissions = () => {
	const permissions = [
		'VIEW_UNFILLED_SHIFTS', 'VIEW_NON_PARTICIPANTS_SHIFTS', 'VIEW_RATE_ESCALATED_SHIFTS', 'VIEW_DRAFTED_SHIFTS',
	];
	const findCommon = _.intersection(currentUserRolePermissions.value, permissions);
	return findCommon?.length > 0;
};

// Watchers
watch(isLogged, async (value) => {
	if (value) {
		isLoadingOptions.value = true;
		await store.dispatch('getFirebaseDb');
		getUnreadMessagesCounter(db.value, account.value.id, (data) => {
			store.dispatch('messenger/setNotifications', data);
		});
		subscribeNotifications(db.value, account.value.id, (data) => {
			store.dispatch('messenger/setNotifications', data);
		});

		isLoadingOptions.value = false;
		store.dispatch('loadNotificationsCount');
		store.dispatch('completeInitialLoad');
	}
}, { immediate: true });

watch(currentTrustId, async (value) => {
	if (value) {
		store.dispatch('getGlobalTrustFeatureSetupList', { trustId: value });
	}
}, { immediate: true });

// Handle document-level click to close popover
const handleDocumentClick = (event) => {
	const userMenuEl = userMenu.value?.$el || userMenu.value;
	if (userMenuEl && !userMenuEl.contains(event.target) && isOpenPopover.value) {
		isOpenPopover.value = false;
	}
};

// Lifecycle hooks
onMounted(() => {
	setEnvironment();
	loadUserData();
	document.addEventListener('click', handleDocumentClick);
});

onBeforeUnmount(() => {
	document.removeEventListener('click', handleDocumentClick);
});
</script>

<style>
.logout-icon {
    width: 15px;
    height: 12px;
}

* {
    font-family: "Source Sans Pro";
}

.dropdown-menu.show {
    background-color: rgb(5, 19, 118);
}

.avatar {
    text-transform: uppercase;
    line-height: 35px;
    background: #e7ebf1;
    color: black;
    font-family: 'Source Sans Pro Light';
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
}

.modal-content {
    background: white;
    border-radius: 4px;
    padding: 20px;
    max-width: 500px;
    width: 100%;
}

.modal-content.modal-md {
    max-width: 600px;
}

.modal-content.modal-sm {
    max-width: 300px;
}

.switchRoleComponent {
    margin-left: 40px;
    display: flex;
    margin-right: -40px;
}

.switchRoleComponent .switchbtn {
    color: rgb(5, 19, 118);
    font-size: 13px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    text-decoration: none;
    background-image: url('../../assets/feedback/role-switch.png');
    background-size: 120px 120px;
    height: 140px;
    width: 120px;
    outline: none;
}

.switchRoleComponent .switchbtn-active {
    color: rgb(5, 19, 118);
    font-size: 13px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    text-decoration: none;
    background-image: url('../../assets/feedback/active-role.png');
    background-size: 120px 120px;
    height: 140px;
    width: 120px;
    outline: none;
}

.message-badge, .notification-badge {
    position: absolute;
    right: 1px;
    top: 11px;
}

.message-container, .notification-container {
    position: relative;
}

@media screen and (min-width: 1600px) {
    .nav_mobile {
        display: none;
    }
    .nav_desktop {
        display: flex;
    }
}

@media screen and (max-width: 1599px) {
    .nav_mobile {
        display: flex;
    }
    .nav_desktop {
        display: none;
    }
}

.navbar-list {
    flex-wrap: wrap;
}

.successBtn {
    min-width: 130px;
}

.envNmae {
    font-family: 'Proxima Nova Regular';
    color: rgba(5, 19, 118, 1);
    background-color: rgba(111, 218, 165, 1);
    border-radius: 5px;
    padding: 2px 10px;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    margin-left: 7px;
    margin-top: 7px;
}
</style>

<style lang="scss" module>
@import "../../styles/variables.scss";

.popoverList {
    width: 200px;
    font-family: "Source Sans Pro", serif;
    font-size: 14px;
    color: $sp-color-text-dark;
    border-radius: 3px;
    box-shadow: 0 1px 0 0 #eff1f5;
    background-color: #ffffff;
}

.listItem {
    padding: 10px 15px;
    color: $sp-color-text-dark;
    text-decoration: none;
    border-bottom: 1px solid lightgray;
    cursor: pointer;

    &:hover {
        background-color: $gray-200;
        text-decoration: none;
    }
}

.navItem {
    display: flex;
    align-items: center;
}

.userHover:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

.userMenu {
    display: flex;
    flex-flow: row;
    cursor: pointer;
}

.role {
    font-size: 11px;
    color: $sp-color-light-blue;
    text-transform: uppercase;
}

.user {
    font-size: 15px;
    color: $white;
}

.top-nav {
   display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
    margin-left: 10px !important;
    margin-right: 10px !important;
}

@font-face {
    font-family: "Source Sans Pro Light";
    src: url("../../../public/fonts/sourcesanspro/sourcesanspro-light.woff") format("woff");
}

@font-face {
    font-family: "Source Sans Pro Bold";
    src: url("../../../public/fonts/sourcesanspro/sourcesanspro-bold.woff") format("woff");
}

@font-face {
    font-family: "Source Sans Pro";
    src: url("../../../public/fonts/sourcesanspro/sourcesanspro.woff") format("woff");
}
</style>
<style>
@import 'bootstrap-icons/font/bootstrap-icons.css';
</style>
<style scoped>
.popover{
      margin-top: 110px;
}
.popoverList {
    margin-top: 110px !important;
    left: 100px !important;
}</style>
